// src/pages/in-kind/RequestInput.js
import InKindInputForm from "../../components/InKindInputForm";

function RequestInput() {
  return <InKindInputForm contributionType="need" />;
}

export default RequestInput;